import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Linkedin } from "lucide-react";
import Logo from "../assets/logo-prev.png";
import "../styles/Footer.css";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const socialLinks = [
        {
            icon: <Instagram size={16} />,
            href: "https://www.instagram.com/rosdormentesdormentes",
            label: "Instagram",
        },
        { icon: <Facebook size={16} />, href: "#", label: "Facebook" },
        { icon: <Linkedin size={16} />, href: "#", label: "LinkedIn" },
    ];

    const quickLinks = [
        { to: "/", label: "Início" },
        { to: "/empresa", label: "Empresa" },
        { to: "/produtos", label: "Produtos" },
        { to: "/projetos", label: "Projetos" },
        { to: "/contato", label: "Contato" },
    ];

    const products = [
        "Assoalhos, Pisos e Decks",
        "Para Construção",
        "Ambientes Externos",
        "Ambientes Internos",
    ];

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-grid">
                    {/* Company Info */}
                    <div>
                        <div className="logo">
                            <img src={Logo} alt="Ros Dormentes Logo" className="logo-image" />
                        </div>
                        <p className="footer-description">
                            Trabalhamos com madeiras de demolição de alta qualidade, oferecendo
                            soluções sob medida para ambientes internos e externos, com
                            sustentabilidade, beleza e durabilidade.
                        </p>
                        <div className="footer-social">
                            {socialLinks.map((social, i) => (
                                <a
                                    key={i}
                                    href={social.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={social.label}
                                >
                                    {social.icon}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3>Links Rápidos</h3>
                        <ul>
                            {quickLinks.map((link, i) => (
                                <li key={i}>
                                    <Link to={link.to}>{link.label}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Products */}
                    <div>
                        <h3>Nossos Produtos</h3>
                        <ul>
                            {products.map((product, i) => (
                                <li key={i}>{product}</li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h3>Contato</h3>
                        <div className="contact-item">
                            <Phone className="icon" />
                            <div>
                                <p>(32) 99110-0949</p>
                                <p>(32) 99977-7220</p>
                            </div>
                        </div>
                        <div className="contact-item">
                            <Mail className="icon" />
                            <p>rosdormentes@hotmail.com</p>
                        </div>
                        <div className="contact-item">
                            <MapPin className="icon" />
                            <div>
                                <p>Rua Analia Lancetti Randi, 37-A</p>
                                <p>Bom Pastor, São João del Rei - MG</p>
                                <p>CEP: 36305-276</p>
                            </div>
                        </div>
                        <div className="footer-schedule">
                            <h4>Horário de Atendimento</h4>
                            <p>Segunda à Sexta: 8h às 18h</p>
                            <p>Sábado: 8h às 12h</p>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="footer-bottom">
                    <p>© {currentYear} ROS Dormentes. Todos os direitos reservados.</p>
                    <div className="footer-policy">
                        <Link to="/politica-de-privacidade">Política de Privacidade</Link>
                        <Link to="/termos-de-uso">Termos de Uso</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
